/**
 * Polyfill for react-native-responsive-fontsize's RFValue function
 * For web, we return the font size value directly without responsive scaling
 * since web browsers handle responsive fonts via CSS media queries
 */
export function RFValue(fontSize: number) {
  // For web, just return the fontSize value
  // You can add viewport-based scaling here if needed
  // For example: return fontSize * (window.innerWidth / 375) for mobile-first scaling
  return fontSize
}

export default RFValue
